(() => {
  'use strict';
  const positive = value => Number.isFinite(Number(value)) && Number(value) > 0;
  const format = value => value > 0 && value < 0.01 ? '<0.01' : new Intl.NumberFormat(document.documentElement.lang || 'en', { maximumFractionDigits: 2 }).format(value);
  const text = (root, selector, value) => root.querySelectorAll(selector).forEach(node => { node.textContent = format(value); });

  if (!customElements.get('cbd-liquid-guide')) customElements.define('cbd-liquid-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      this.scope = this.closest('[data-product-scope]');
      this.scope?.addEventListener('change', event => {
        if (event.target.matches('[data-variant-option],[data-variant-select]')) this.update(event.target.value);
      }, { signal: this.abort.signal });
      this.querySelector('[data-cbd-target]')?.addEventListener('input', () => this.convert(), { signal: this.abort.signal });
      this.update(this.selectedVariant());
      window.addEventListener('pageshow', () => this.update(this.selectedVariant()), { signal: this.abort.signal });
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.abort = null;
      document.dispatchEvent(new CustomEvent('dg:cbd-bottle-change', { detail: { productId: this.dataset.productId } }));
    }
    selectedVariant() {
      return this.scope?.querySelector('[data-product-form] [name="id"]:checked')?.value || this.scope?.querySelector('[data-product-form] select[name="id"]')?.value || this.dataset.initialVariant;
    }
    update(id) {
      const record = Array.from(this.querySelectorAll('[data-cbd-variant]')).find(node => node.dataset.cbdVariant === String(id));
      const total = Number(record?.dataset.total), volume = Number(record?.dataset.volume);
      this.bottle = { total, volume, valid: positive(total) && positive(volume) };
      this.querySelector('[data-cbd-content]').hidden = !this.bottle.valid;
      this.querySelector('[data-cbd-missing]').hidden = this.bottle.valid;
      if (this.bottle.valid) {
        text(this, '[data-cbd-total]', total);
        text(this, '[data-cbd-volume]', volume);
        this.querySelectorAll('[data-cbd-spoon]').forEach(node => { node.textContent = format(total / volume * Number(node.dataset.cbdSpoon)); });
        const input = this.querySelector('[data-cbd-target]');
        if (input) input.max = total;
      }
      this.convert();
      document.dispatchEvent(new CustomEvent('dg:cbd-bottle-change', { detail: { productId: this.dataset.productId } }));
    }
    convert() {
      const input = this.querySelector('[data-cbd-target]');
      if (!input) return;
      const blank = input.value === '' && !input.validity.badInput;
      const mg = Number(input.value), valid = this.bottle?.valid && !blank && positive(mg) && mg <= this.bottle.total;
      this.querySelector('[data-convert-empty]').hidden = !blank;
      this.querySelector('[data-convert-invalid]').hidden = blank || valid;
      this.querySelector('[data-convert-value]').hidden = !valid;
      input.setAttribute('aria-invalid', String(!blank && !valid));
      if (valid) {
        const ml = mg / this.bottle.total * this.bottle.volume;
        text(this, '[data-target-ml]', ml);
        text(this, '[data-target-tsp]', ml / 5);
        text(this, '[data-target-tbsp]', ml / 15);
      }
    }
  });

  if (!customElements.get('cbd-wing-recipe')) customElements.define('cbd-wing-recipe', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      this.querySelector('[data-wing-count]').addEventListener('input', () => this.update(), { signal: this.abort.signal });
      document.addEventListener('dg:cbd-bottle-change', event => {
        if (event.detail.productId === this.dataset.productId) this.update();
      }, { signal: this.abort.signal });
      document.addEventListener('shopify:section:load', () => this.update(), { signal: this.abort.signal });
      // Guide and recipe may load in either order, including in the theme editor.
      this.update();
    }
    disconnectedCallback() { this.abort?.abort(); this.abort = null; }
    update() {
      const guide = Array.from(document.querySelectorAll('cbd-liquid-guide')).find(node => node.dataset.productId === this.dataset.productId);
      const bottle = this.dataset.sync === 'true' ? guide?.bottle : { total: Number(this.dataset.total), volume: Number(this.dataset.volume) };
      const input = this.querySelector('[data-wing-count]'), count = Number(input.value);
      const validCount = Number.isInteger(count) && count >= 1 && count <= 200;
      const valid = validCount && positive(bottle?.total) && positive(bottle?.volume);
      this.querySelector('[data-wing-results]').hidden = !valid;
      this.querySelector('[data-wing-unavailable]').hidden = valid;
      this.querySelector('[data-wing-count-error]').hidden = validCount;
      input.setAttribute('aria-invalid', String(!validCount));
      if (validCount) text(this, '[data-wing-yield]', count);
      if (valid) {
        text(this, '[data-wing-total]', bottle.total);
        text(this, '[data-wing-volume]', bottle.volume);
        text(this, '[data-wing-mg]', bottle.total / count);
        text(this, '[data-wing-sauce]', bottle.volume / count);
      }
    }
  });
})();
